import React, { Fragment } from 'react';
import { ArcaField } from '../../../code/ArcaField';
import { ArcaHttpClientLogin } from '../../../code/ArcaHttpClientLogin';
import { ArcaPageFieldState } from '../../../code/ArcaPageFieldState';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaPersonLogin } from '../../../code/Types/ArcaPersonLogin';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { InputField } from '../Fields/InputField';
import { StatusBar } from '../StatusBar';
import { TermsAndConditions } from './TermsAndConditions';

export class LoginPanel
    extends ArcaComponent {

    constructor(props) {
        super(props);

        var person = new ArcaPersonLogin();

        this.state = {
            formState: this.buildFields(person),
            person: person,
            statusText: null,
            isError: false,
            checked: false,
            formValid: false
        };
    }

    render() {
        return (
            <Fragment>
                <h1 id="tabelLabel" className='centerText'>Login</h1>
                <p>Please enter your email address and password to login.</p>

                {this.state.formState.Fields.map((f, k) =>
                    <InputField
                        label={f.FieldLabel}
                        fieldname={f.FieldName}
                        key={k}
                        regularExpression={f.Validation}
                        warnText='Invalid format'
                        mandatory={f.IsMandatory}
                        value={f.Value}
                        onUpdate={this.onUpdate.bind(this)}
                        fieldValid={f.IsValid}
                        fieldClass='simpleInputField' />
                )}

                <StatusBar isError={this.state.isError} message={this.state.statusText} />

                <ArcaLink
                    colour='primary'
                    onClick={this.onLogonAttempt.bind(this)}
                    disabled={!this.state.formValid}
                    text='Login'
                    width='100%' />

                {!this.state.checked
                    ? <ArcaLink
                        height={'40px'}
                        width='100%'
                        colour='primary'
                        text='Confirm cookies and terms' onClick={(() => {
                            this.setState({
                                checked: !this.state.checked,
                                formValid: this.state.formState.IsValid && !this.state.checked
                            })
                        })} />
                    : null}
                <TermsAndConditions showText={true} isVisible={false} />

                <p>This site uses cookies (well a session cookie) so that it can function. There will be no tracing, nor passing on of any data
                which you provide to the site. All data is for the use of running the business of looking after your pets effectively and will
                                    be used for no other purposes.</p>

                {/*<ArcaLink colour='secondary' text='Change password' link={'/ChangePassword'} width='50%' />*/}
                <ArcaLink colour='secondary' text='Forgotten' link={'/Forgotten'} width='100%' />

            </Fragment>
        );
    }

    onUpdate(value, isValid, fieldName) {

        var field = this.state.formState.GetField(fieldName)
        field.Value = value
        field.IsValid = isValid

        let { person } = this.state;
        person[fieldName] = value;

        this.setState({
            person: person,
            formState: this.state.formState,
            disabled: false,
            formValid: this.state.formState.IsValid && this.state.checked,
        });
    }

    buildFields(person) {
        var formState = new ArcaPageFieldState();
        formState.AddField(new ArcaField("Email", "Email", person.Email, true, true, 'text', 'email'));
        formState.AddField(new ArcaField("Password", "Password", person.Password, true, true, 'text', 'password'));

        return formState;
    }

    async onLogonAttempt() {
        try {

            ArcaHttpClientLogin.LoginAsync(
                this.state.person.Email,
                this.state.person.Password,
                (user => {
                    ArcaSecurity.Logon(user.token, user.id, user.type, this.state.person.Email)
                    this.setState({
                        statusText: "Logon successful",
                        isError: false,
                        formValid: false
                    });
                    this.props.onLogon();
                }),
                (message => {
                    this.setState({
                        formValid: true,
                        statusText: "Your logon failed",
                        isError: true
                    })
                })/*.bind(this)*/);
            /*eslint-enable */
        }
        catch (error) {
            this.setState({
                formValid: true,
                statusText: error,
            });
        }
    }
}